import { SpectraDeviceType } from "../views/components/Common/SpectraDeviceTypeSelect";
import { IChemicalValueFilterItem } from "../views/components/SampleRecordsDataTable/ChemicalValueFilter";
import { CropTypes } from "./chemicals";

export interface SampleRecordFilterParams {
  companyId?: string;
  sampleSource?: string;
  dataSource?: string;
  sampleClient?: string;
  bagWeight?: number;
  searchTerm?: string;
  chemicalFilters?: IChemicalValueFilterItem[];
  /**
   * Uploaded date range filter (mapped to SampleRecord.createdAt on backend).
   * Use ISO strings for consistent JSON transport.
   */
  uploadedFromDate?: string;
  uploadedToDate?: string;
  rangeFilterFieldName?: string;
  minUid?: string;
  maxUid?: string;
  uids?: number[];
  cropType?: CropTypes;
  deviceType?: SpectraDeviceType;
  sortModel?: { [key: string]: number };
}
export interface ITimestamp {
  nanos: number;
  seconds: number;
}

export interface IActionByMetadata {
  displayName: string;
  ssoUserId: string;
  userId: string;
}

export interface IPhoneNumber {
  phoneNumber: string;
  phoneType: string;
}

export enum FilterOperators {
  greaterThan = ">=",
  lessThan = "<=",
  between = "><",
}

export enum GasReportVariation {
  DairyCarbon = 1,
  Dairy = 2,
  BeefCarbon = 3,
  DairyV2 = 4,
}

export const GasReportTypes = [
  {
    name: "Dairy Carbon",
    value: GasReportVariation.DairyCarbon,
  },
  {
    name: "Dairy",
    value: GasReportVariation.Dairy,
  },
  {
    name: "Dairy V2",
    value: GasReportVariation.DairyV2,
  },
  {
    name: "Beef Carbon",
    value: GasReportVariation.BeefCarbon,
  },
];

function knownGasReportTypeValues(values?: number[]) {
  const result: number[] = [];
  (values || []).forEach((value) => {
    const numeric = Number(value);
    if (
      GasReportTypes.some((type) => type.value === numeric) &&
      !result.includes(numeric)
    ) {
      result.push(numeric);
    }
  });
  return result;
}

/** Selection order. The first value is the company's default gas report type. */
export function companyGasReportTypeSelection(company?: {
  allowedGasReportTypes?: number[];
  defaultGasReportType?: number;
}): number[] {
  if (Array.isArray(company?.allowedGasReportTypes)) {
    return knownGasReportTypeValues(company.allowedGasReportTypes);
  }
  const defaultType = Number(company?.defaultGasReportType);
  if (GasReportTypes.some((type) => type.value === defaultType)) {
    return [defaultType];
  }
  return [GasReportVariation.DairyCarbon];
}

/** Types a company user can pick. An unsaved company still allows every type. */
export function gasReportTypeOptionsForCompany(company?: {
  allowedGasReportTypes?: number[];
}) {
  if (!Array.isArray(company?.allowedGasReportTypes)) return GasReportTypes;
  return knownGasReportTypeValues(company.allowedGasReportTypes)
    .map((value) => GasReportTypes.find((type) => type.value === value))
    .filter((type): type is (typeof GasReportTypes)[number] => !!type);
}
